// Enums
export enum ContactType {
  customer = 0,
  prospect = 1,
  locationContact = 2,
}

export enum CustomerType {
  private = 0,
  company = 1,
}

export enum SavedFileStatus {
  ACCEPTED = "akzeptiert",
  DECLINED = "abgelehnt",
  UNKNOWN = "unbekannt",
}

export enum Role {
  Guest = 0,
  Partner = 50,
  SGB = 100,
}

export enum NewStatus {
  PARKED = "Parked", // Geparkter Auftrag
  CREATED = "Created", // Ersteller Auftrag
  REJECTED = "Rejected", // Auftrag abgelehnt
  // COMPLETED = "Completed", // Vollständer Auftrag (inkl. Dokumente)
  RETURNED_FOR_REWORK = "ReturnedForRework", // Auftrag zurückgewiesen – Nacharbeit notwendig (SGB)
  RETURNED_FOR_REWORK_PARTNER = "ReturnedForReworkPartner", // Auftrag zurückgewiesen – Nacharbeit notwendig (Partner)
  RELEASED = "Released", // Auftrag freigegeben
  MARKET_COMMUNICATION = "MarketCommunication", // Marktkommunikation
  MARKET_COMMUNICATION_ISSUE = "MarketCommunicationIssue", // Klärfall Marktkommunikation
  MARKET_COMMUNICATION_SUCCESSFUL = "MarketCommunicationSuccessful", // Erfolgreich Marktkommunikation
  IN_DELIVERY = "InDelivery", // In Belieferung
  CANCELLED_BY_CUSTOMER = "CancelledByCustomer", // Kunde hat gekündigt
  CUSTOMER_IS_TERMINATED = "CustomerIsTerminated", // Kunde ist gekündigt
  PAPER_ORDER = "PaperOrder", // Papierauftrag
  DIPLOMA_ORDER = "DiplomaOrder", // Diplomauftrag
  REFUSED_BY_CUSTOMER = "RefusedByCustomer", // Storno Widerruf (abgelehnt)
  REFUSED_CREDIT = "RefusedCredit", // Storno Bonität (abgelehnt)
  NEEDS_CLARIFICATION = "NeedsClarification", // Klärfall beim Anbieter
  REFUSED_BY_PARTNER = "RefusedByPartner", // Wiederruf Partner (abgelehnt) 
}

export enum TariffTypes {
  S_Gas_RLM_12 = "S_Gas_RLM_12",
  S_Gas_RLM_mA = "S_Gas_RLM_mA",
  S_Strom_RLM_1_mA = "S_Strom_RLM_1_mA",
  S_Strom_RLM_12 = "S_Strom_RLM_12",
  S_Strom_SLP_12_LFT = "S_Gas_RLM_24",
}

export enum Priority {
  low = 0,
  medium = 1,
  high = 2,
}

export enum ActivityType {
  call,
  meeting,
  task,
  deadline,
}

export enum CommissionStatus {
  created = 0,
  approved = 1,
  blocked = 2,
  transferred = 3,
}

export enum Title {
  mr = 0,
  ms = 1,
  other = 2,
}

export enum DeliveryPointType {
  household = 0,
  business = 1,
}

export enum Duration {
  oneMonth = 1,
  oneYear = 12,
  twoYears = 24,
  threeYears = 36,
}

export enum Medium {
  gas = "gas",
  electricity = "strom",
  prosumer = "prosumer",
}

export enum ContractStatus {
  active,
  finished,
  terminated,
  negotiation,
  sentToSGB,
}

export enum PreviousContractStatus {
  customerTerminates = 0,
  sgbTerminates = 1,
  isTerminated = 2,
}

export enum DeliveryPointStatus {
  active = 0,
  finished = 1,
}

export enum DeliveryReason {
  supplierChange = 0,
  movingIn = 1,
}

export enum BillingAddressFor {
  Partner = "Partner",
  Customer = "Customer",
  Contract = "Contract"
}

// Interfaces
export interface EntityBase {
  creationDate: Date;
  updateDate: Date;
}

export interface Supplier {
  id: string;
  name: string;
  Marktfunktion: string;
  Marktrollen: string;
  Bundesland: string;
  Postleitzahl: string;
  Ort: string;
  Straße: string;
  Hausnummer: string;
  Land: string;
  Registrierungsdatum: string;
}

export interface SavedFile extends EntityBase {
  id: string;
  comment?: string;
  containerName: string;
  contract?: Contract;
  contractId?: string;
  customer?: Customer;
  customerId?: string;
  mimeType: string;
  originalName: string;
  partner?: Partner;
  partnerId?: string;
  size: number;
  status: SavedFileStatus;
 
}

export interface Customer extends EntityBase {
  id: string;
  address: Address;
  addressId: string;
  billingAddress?: BillingAddress;
  billingAddressId?: string;
  bankData?: BankData;
  bankDataId?: string;
  companyName?: string | null;
  contact: Contact;
  contactId: string;
  createdBy?: Partner;
  createdById?: string;
  crefoNumber?: string;
  customerNumber?: string;
  deliveryPointAccounts: DeliveryPointAccount[];
  locations: Location[];
  activities: Activity[];
  note?: Note;
  noteId?: string;
  priority: Priority;
  referredBy?: Contact;
  referredById?: string;
  referredByText?: string;
  savedFiles: SavedFile[];
  type: CustomerType;
  contract?: Contract[];

}

export interface Order {
  id: string;
  description?: string; 
}

export interface ConsumptionReportJobs extends EntityBase  {
  id: string;
  created_by_user?: string;
  job_meta?: Record<string, any>; 
  orderId?: string;
  order?: Order;
}

export interface ConsumptionReport extends EntityBase  {
  id: string;
  balancingEnergy?: number;
  basePrice?: number;
  commission?: number;
  invoicePrice?: number;
  serviceFee?: number;
  spotPrice?: number;
  consumptionInvoice?: number;
  description: string;
  billingStart?: Date;
  billingEnd?: Date;
  billingType?: string;
  contractId?: number;
  customerId?: number;
  marketLocationID?: string;
  consumptionReportJobId?: string;
  consumptionReportJob?: ConsumptionReportJobs; 
  meterNumber?: string;
  meterNumberCustomer?: string;
  status: ConsumtionReportStatusEnum; 
  statusMessage?: string;
  duplicateConsumtionReportId?: string;
  duplicateConsumtionReport?: ConsumptionReport; 

}

export enum ConsumtionReportStatusEnum {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
}


export interface Contract extends EntityBase {
  id: string;
  balanceEnd?: Date;
  balanceStart?: Date;
  bankData?: BankData;
  newStatus: NewStatus;
  bankDataId?: string;
  basePrice?: number;
  address?: Address;
  addressId?: string;
  billingAddress?: BillingAddress[];
  billingAddressId?: string;
  billingaddresses?: BillingAddress[];
  isProsumerAlreadyCanceled?: boolean;
  prosumerEndDate?: Date;
  commissions: Commission[];
  consumption: number;
  contractAccounts: ContractAccount[];
  customer: Customer;
  customerId: string;
  debitSymbol: string;
  typeProsumer?: string;
  deliveryEnd?: Date;
  deliveryPoints: DeliveryPoint[];
  deliveryReason?: DeliveryReason;
  deliveryStart?: Date;
  description: string;
  descriptionDate?: string;
  duration?: Duration;
  egonNumber: number;
  email: string;
  export?: Date;
  import?: Date;
  isCompanySepa?: boolean;
  isEco?: boolean;
  kwhPrice: number;
  minContractEnd?: Date;
  minContractStart?: Date;
  otherReasonForDelivery?: string;
  partner: Partner;
  partnerId: string;
  previousContractStatus?: PreviousContractStatus;
  rate: number;
  savedFiles: SavedFile[];
  status: ContractStatus;
  statusDescription: string;
  type: string;
  contractCode: string; 
  isNewRelease?: boolean;
  fileId?: string;
  minimumTerm?: number;
  cancellationPeriodDays?: number;
  cancellationPeriodMonths?: Date;
  tariffId?: string;
  tariffName?: string;
}

export interface Contact extends EntityBase {
  id: string;
  birthDate?: Date;
  contractAccounts: ContractAccount[];
  customer?: Customer;
  customerSuggestion: Customer[];
  email?: string;
  firstName: string;
  lastName: string;
  mobileNumber?: string;
  newsletter: boolean;
  phoneNumber?: string;
  title: Title;
  type: ContactType;
  gender: Gender;

}

export interface BankData extends EntityBase {
  id: string;
  accountHolder?: string;
  accountHolderFirstName?: string;
  accountHolderLastName?: string;
  accountNumber?: string;
  bankIdCountry: string;
  bankIdentifierCode?: string;
  bankName: string;
  defaultReasonForTransfer?: string;
  iban: string;
  partner?: Partner;
  partnerId?: string;
  swift: string;

}

export interface Activity extends EntityBase {
  id: string;
  activityType: ActivityType;
  customer: Customer;
  customerId: string;
  deliveryPoint?: DeliveryPoint;
  deliveryPointId?: string;
  description: string;
  end?: Date;
  isFinished: boolean;
  latitude?: number;
  longitude?: number;
  note?: Note;
  noteId?: string;
  partner: Partner;
  partnerId: string;
  start?: Date;
  title: string;
}

export interface DeliveryPoint extends EntityBase {
  id: string;
  activities: Activity[];
  annualConsumption: string;
  billingAddress?: Address;
  billingAddressId?: string;
  consumptionPoint: string;
  contactPerson: Contact;
  contactPersonId: string;
  contracts: Contract[];
  currentElectricityProvider: string;
  currentGasProvider: string;
  deliveryPointNumber: string;
  energyMeters: EnergyMeter[];
  isInterestedInElectricity: boolean;
  isInterestedInGas: boolean;
  lastprofilType: string;
  location: Location;
  locationId: string;
  malo: string;
  medium: Medium;
  note?: Note;
  noteId?: string;
  operator: string;
  partner: Partner;
  partnerId: string;
  status: DeliveryPointStatus;
  transmissionOperator: string;
  type: DeliveryPointType;
}

export interface IPartnerUpdateHistory extends EntityBase {
  id: string;
  deletedAt: string | null;
  oldData: Record<string, any>;
  updatedData: Record<string, any>;
  updatedBy?: string;
}

export interface Partner extends EntityBase {
  id: string;
  addressId: string;
  address: Address;
  partnerNumber: string;
  bankDatas: BankData[];
  sendMailResetPasswordExpiredDate?: Date;
  commissions: Commission[];
  companyName: string;
  contactId: string;
  contact: Contact;
  parentResellerId?: string;
  parentReseller?: Partner;
  favoredResellerId?: string;
  favoredReseller?: Partner;
  distDistributionChannel: string;
  distributionChannelId:string;
  distributionChannelLevelId:string;
  distributionChannelLevelHistory: IdistributionChannelLevelsHistory[];
  partnerUpdateHistory: IPartnerUpdateHistory[];
  extVpName: string;
  identifier: string;
  password: string;
  role: Role;
  establishmentDate: Date;
  legalCity: string;
  isSubjectedToVat: boolean;
  taxCode1: string;
  taxCode2: string;
  referencePersonId?: string;
  referencePerson?: Partner;
  referencePersons: Partner[];
  resellerFixedStructure: string;
  savedFiles: SavedFile[];
  status: string;
  structureNumber: string;
  companyType?: string;
  billingaddresses?: BillingAddress[];
  isBlockedSepa?: boolean;
  isBlockedBilling?: boolean;
}

export interface Note extends EntityBase {
  id: string;
  text: string;
  title: string;
}

export interface GetecInformation extends EntityBase {
  id: string;
  getecContractNumber: string;
  getecCustomerNumber: string;
}

export interface BillingContract extends EntityBase {
  id: string;
  basePrice: number;
  boundUntil: string;
  compensationEnergyNet: number;
  contractAccount: ContractAccount;
  contractAccountId: string;
  currentDeduction: number;
  deliveryPointAccount?: DeliveryPointAccount;
  deliveryPointAccountId?: string;
  description: string;
  medium: Medium;
  number: string;
  serviceRate: number;
  type: string;
}

export interface Location extends EntityBase {
  id: string;
  address: Address;
  addressId: string;
  area?: string;
  buildYear?: string;
  billingAddress?: BillingAddress[];
  billingAddressId?: string;
  customer: Customer;
  customerId: string;
  deliveryPoints: DeliveryPoint[];
  objectStatus?: string;
  objectType?: string;
  roofAlignment?: string;
  roofAngle?: string;
  roofArea?: string;
  roofCoverage?: string;
}

export interface ContractAccount extends EntityBase {
  id: string;
  billingContracts: BillingContract[];
  claim: string;
  class: string;
  contract?: Contract;
  contractId?: string;
  customer: Customer;
  customerId: string;
  identifier: string;
  number: string;
  type: string;
}

export interface Commission extends EntityBase {
  id: string;
  amount: number;
  commission: number;
  contract: Contract;
  contractId: string;
  date: string;
  partner: Partner;
  partnerId: string;
  status: CommissionStatus;
}

export interface EnergyMeter extends EntityBase {
  id: string;
  confirmedNumber?: string;
  deliveryPoint: DeliveryPoint | null;
  deliveryPointId: string | null;
  medium: Medium;
  prosumerNumber?: string;
  unconfirmedNumber: string;
}

export interface DeliveryPointAccount extends EntityBase {
  id: string;
  activeBillingContract?: BillingContract;
  activeBillingContractId?: string;
  billingContracts: BillingContract[];
  customer: Customer;
  customerId: string;
  deliveryPoint: DeliveryPoint;
  deliveryPointId: string;
  number: string;
}

export interface Address extends EntityBase {
  id: string;
  addressAddition?: string;
  city: string;
  geoLocation?: string;
  houseNumber: string;
  latitude?: number;
  longitude?: number;
  postalCode: string;
  street: string;
}

export interface BillingAddress extends EntityBase {
  id: string;
  address: Address;
  addressId: string;
  isCompany: boolean; 
  sendEmail: boolean;
  email: string;
  billingAddressFor: BillingAddressFor;
  customerId: string;
  partnerId: string;
  contractId: string;
  gender: Gender;
  firstName: string;
  lastName: string;
  companyName: string;
}

// Spot market interfaces
export interface SpotBase extends MontelBase {
  date: string;
  spotName: string;
  unit: string;
  value: number;
}

export interface SpotElectricity extends SpotBase {
  id: string;
}

export interface SpotGas extends SpotBase {
  id: string;
}

export interface SpotElectricityDay extends SpotBase {
  id: string;
}

export interface SpotGasDay extends SpotBase {
  id: string;
}

// Derivative market interfaces
export interface DerivativeElectricity extends MontelBase {
  id: string;
  base1: number;
  base2: number;
  base3: number;
  date: string;
  peak1: number;
  peak2: number;
  peak3: number;
}

export interface DerivativeGas extends MontelBase {
  id: string;
  date: string;
  theGas1: number;
  theGas2: number;
  theGas3: number;
}

export interface MontelBase extends EntityBase {
  date: string;
}

export interface ReportBug extends EntityBase{
  id?: string;
  title?:string;
  description?:string;
  createdByUser?:string;
  imagePath?:string
}
export interface SaleProps {
  id?: string;
  creationDate?: string;
  deletedAt?: string;
  updateDate?: string;
  description?: string;
  name?: string;
  percentageShare: number;
  slpFixProvision: number;
  active?: boolean;
  sorting: number;
  distributionChannelId?: string;
  createdById?: string;
}
export interface Product extends EntityBase{
  id:string;
  providerId?: string;
  distributorId?: string;
  name?: string;
  description?: string;
  productType?: string;
  customerType?: string;
  loadProfile?: string;
  tariffCode?: string;
  active?: boolean;
  createdById?: string;
  commissionInputs?: any;
}
export interface CommissionInput {
  bookingInterval?: string;
  calculationStructure: boolean;
  calculationType: CalculationType;
  commissionBudget?: number;
  createdBy?: Partner;
  createdById?: string;
  validFrom?: Date;
  validTo?: Date;
  provisionType: ProvisionType;
  product?: Product;
  productId?: string;
}
// TODO
export enum CalculationType {
  PERCENTAGE = "Percentage",
  ABSOLUTELY = "Absolutely",
}
export enum ProvisionType {
  FIXED_PROVISIONING = "FixedProvisioning",
  BASED_ON_ORDER_CONSUMPTION_PROVISIONING = "BasedOnOrderConsumptionProvisioning",
}

export interface IDistributionChannelLevels {
  id?: string;
  creationDate?: string;
  deletedAt?: string;
  updateDate?: string;
  description?: string;
  name?: string;
  percentageShare: number;
  slpFixProvision: number;
  active?: boolean;
  sorting: number;
  distributionChannelId?: string;
  createdById?: string;
}

export interface IdistributionChannelLevelsHistory {
  id?: string;
  creationDate?: string;
  deletedAt?: string;
  updateDate?: string;
  dateFrom?: string;
  dateTo: string;
  distributionChannelId?: string;
  distributionChannelLevelId?: string;
  partnerId?: string;
}

export interface Notification extends EntityBase {
  id?: string;
  title: string;
  description: string;
  isRead: boolean;
  link: string;
  type: string;
  createdByName?: string;
  receiverName?: string;
}

export interface IDistributionChannel {
  id?: string;
  creationDate?: string;
  deletedAt?: string;
  updateDate?: string;
  name?: string;
  description?: string;
  calculate_structure?: boolean;
  active?: boolean;
  distributionChannelLevels: IDistributionChannelLevels[];
  createdBy?: { [key: string]: any };
  createdById?: string;
  distributionChannelLevelsHistory: IdistributionChannelLevelsHistory[];
}

export interface TransferDocuments extends EntityBase {
  invoiceId: string;
  partnerId: string;
  documentPath?: string;
  transferAmount: number;
  transferDate: Date;
  createdById: string;
}

export interface CommisionBookingRates extends EntityBase {
  id: string;
  order?: Order;
  orderId?: string;
  favoredReseller?: Partner;
  favoredResellerId?: string;
  commissionPrice?: number;
  settlementDate?: Date;
  settlementAccounts?: SettlementAccounts;
  settlementAccountsId?: string;
  billingDate?: Date;
  cancellationDate?: Date;
  isPreview: boolean;
  createdById?: string;
  createdBy?: Partner;
  consumptionInPerformancePeriod?: number;
  isCancel: boolean;
  performancePeriodFrom?: Date;
  performancePeriodTo?: Date;
  tax?: number;
  taxRate?: number;
  total?: number;
  invoiceId?: string;
  invoice?: Invoice;
  commissionBookingJobsId?: string;
  commissionBookingJobs?: CommissionBookingJob;
  orderCreationPartnerId?: string;
  orderCreationPartner?: Partner;
  partnerId?: string;
  partner?: Partner;
  contractId?: string;
  contract?: Contract;
  rlmTotalStructure?: number;
  careerLevel?: number;
  commissionInput?: CommissionInput;
  commissionInputId?: string;
  commissionOutput?: CommissionOutput;
  commissionOutputId?: string;
}

export interface Invoice extends EntityBase {
  cancellationBilled?: boolean;
  cancellationDate?: Date;
  cancellationNumber: number;
  createdBy?: Partner;
  createdById?: string;
  invoiceDate?: Date;
  invoiceNumber: number;
  sum?: number;
  tax?: number;
  total?: number;
  transferred?: boolean;
  cancellationDocumentId?: string;
  cancellationDocument?: InvoiceDocuments;
  cancellationListId?: string;
  cancellationList?: InvoiceLists;
  partnerId?: string;
  partner?: Partner;
  transferredDocumentId?: string;
  transferredDocument?: TransferDocuments;
  transferListId?: string;
  transferredList?: TransferLists;
  commissionBookingRates?: CommisionBookingRates[];
}

export interface ActionResponse {
  data1: IDistributionChannel;
  updatedList: IDistributionChannel[];
}

export interface FormDataStep1 {
  field1: string;
  field2: string;
  field3: string;
  field4: string;
}

export interface FormDataStep2 {
  field5: string;
  field6: string;
  field7: string;
  field8: string;
}

export interface ActionResponseProvision {
  data: Product[];
}

export enum Gender {
  MALE = "Male",
  FEMALE = "Female",
  OTHER = "Other",
}

export interface SettlementAccounts extends EntityBase {

}

export interface CommissionBookingJob extends EntityBase {

}

export interface CommissionOutput extends EntityBase {

}

export interface InvoiceDocuments extends EntityBase {

}

export interface InvoiceLists extends EntityBase {

}

export interface TransferLists extends EntityBase {

}

